import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "./api";
import type { ListMediaTypesRequest, ListMediaTypesResponse } from "../contracts";

export const mediaTypeApi = createApi({
    reducerPath: "mediaTypeApi",
    baseQuery: baseQueryWithAuth,
    endpoints: builder => ({
        listMediaTypes: builder.query<ListMediaTypesResponse, ListMediaTypesRequest>({
            query: body => ({
                url: "mediatype/list",
                method: "POST",
                body
            })
        })
    })
});

export const { useListMediaTypesQuery } = mediaTypeApi;
